/**
 * @description:localStorage
 */

/**
 * @description:设置localStorage值
 * @param key:键
 * @param value:值
 * @author zhaxianhe
 */
export const set = (key: string, value: any) => {
    try {
        //判断当前value是否是json
        if (value && typeof value === 'object') {
            value = JSON.stringify(value);
        }
        localStorage.setItem(key, value);
    } catch (e) {
        console.error(e);
    }
};

/**
 * @description:获取sessionStorage值
 * @param key:键
 * @returns Object/String
 * @author zhaxianhe
 */
export const get = (key: string) => {
    let str: any = localStorage.getItem(key);
    try {
        return JSON.parse(str);
    } catch (e) {
        return str;
    }
};

/**
 * @description:删除sessionStorage中的元素
 * @param key:键
 * @author zhaxianhe
 */
export const remove = (key: string) => {
    localStorage.removeItem(key);
};

/**
 * @description:清空sessionStorage中的所有元素
 * @author zhaxianhe
 */
export const clear = () => {
    localStorage.clear();
};

/**
 * @description:获取sessionStorage中所有的元素长度
 * @return Number
 * @author zhaxianhe
 */
export const getLength = () => {
    return localStorage.length;
};